import { useEffect } from 'react';
import { toastMessage } from './toast';

export const dateFormat = (date) => {
    return new Date(date).getDate() + '/' + (new Date(date).getMonth()+1) + '/' + new Date(date).getFullYear();
};

export const dateTimeFormat12 = (date) => {
    date = new Date(date);
    let convert12HourFormat = (date) => {
        let hrs, mins, secs, time, meridien;
        hrs = date.getHours(); mins = date.getMinutes(); secs = date.getSeconds();
        meridien = (hrs < 12) ? "AM" : "PM";
        hrs %= 12;
        time = (hrs === 0) ? 12 : hrs;
        return ((time < 10) ? ('0'+time) : time) + ':' + ((mins < 10) ? ('0'+mins) : mins) + ':' + ((secs < 10) ? ('0'+secs) : secs) + ' ' + meridien;
    }

    return new Date(date).getDate() + '/' + (new Date(date).getMonth()+1) + '/' + new Date(date).getFullYear()  + ' ' 
    + convert12HourFormat(date);
};

export const dateTimeFormat = (date) => {
    const time = date;
    return new Date(date).getDate() + '-' + (new Date(date).getMonth()+1) + '-' + new Date(date).getFullYear()  + ' ' 
    + time?.slice(11, 16);
};

export const useOnClickOutside = (ref, handler) => {
    useEffect(
        () => {
            const listener = (event) => {
                if (!ref.current || ref.current.contains(event.target)) {
                    return;
                }
                handler(event);
            };
            document.addEventListener("mousedown", listener);
            document.addEventListener("touchstart", listener);
            return () => {
                document.removeEventListener("mousedown", listener);
                document.removeEventListener("touchstart", listener);
            };
        },
        [ref, handler]
    );
};

export const getParams = (search) => {
    const urlSearchParams = new URLSearchParams(search);
    const params = Object.fromEntries(urlSearchParams.entries());
    return params;
};

export const getDocumentLabel = (name, short) => {
    let label = name.split(/\+/);
    label = (label && label.length === 0) ? name : label[0];
    if (short) {
        label = (label.length > 20) ? label.slice(0,19) + '..' : label;
    }
    return label;
};

export const getDocumentKey = (name) => {
    let label = name.split(/\+/);
    return (label && label.length === 0) ? name : label[1];;
};

export const serializeJsonString = (str) => {
    try{
        let parsedLogData = JSON.parse(str);
        return parsedLogData;
    }
    catch(er){
        toastMessage(
            "error",
            (er) || `Something Went Wrong!`
          );
    }
}

export const downloadFile = (res,jobID=null,docType=null) => {
    var binary_string = window.atob(res.data.content);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
    }
    var blob = new Blob([bytes], { type: res.data.contentType });
    var link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    
    if(jobID==null){
        link.download=res.data.fileName;
    }
    else{
        if(docType!=='vendor'){
            link.download = jobID + "-customer";
        }
        else{
            link.download = jobID +"-"+ docType;
        }
    }
    link.click();
};